<template>
  <div id="chart-line-item-item-box">
    <chart-title
      leftTitle="PDM各厂区生产面积 right_4"
      :rightTitle="`${formatTime(date, 'yyyy年MM月')} 合计：${all_area}`"
      :tooltipText="'开流程卡实时面积'"
    ></chart-title>
    <date-change-card
      height="calc(100% - 30px)"
      @leftClick="leftClick"
      @rightClick="rightClick"
    >
      <div slot="main" style="height: 100%; position: relative">
        <div id="right_4" />
        <div
          class="iconfont icon-sanjiaoxing1 chart_icon_animation animation_rotateY-reverse"
        ></div>
      </div>
    </date-change-card>
  </div>
</template>

<script>
import { plantArea } from "@/api/cockpit/jyl";
import { formatTime, getNextMonth } from "@/utils/index";
import resize from "@/utils/resize";
import ChartTitle from "../../../components/chartTitle";
import DateChangeCard from "../../../components/dateChangeCard";
export default {
  mixins: [resize],
  name: "right_4",
  components: { ChartTitle, DateChangeCard },
  data() {
    return {
      chart: null,
      date: new Date(),
      chartData: "",
      all_area: 0,
    };
  },
  props: {},
  created() {},
  mounted() {
    this.getData();
  },

  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    formatTime,
    //获取数据
    getData() {
      const data = {
        add_time: formatTime(this.date, "yyyy-MM-dd"),
      };
      plantArea(data).then((resp) => {
        this.chartData = Object.values(resp.data.list).map((m) => {
          return {
            value: m.area,
            name: m.name,
          };
        });
        this.all_area = resp.data.all_area;
        this.initChart();
      });
    },
    initChart() {
      this.chart = this.$echarts.init(document.getElementById("right_4"));
      this.setOptions();
    },
    setOptions() {
      this.chart.setOption({
        tooltip: {
          trigger: "item",
        },
        legend: {
          orient: "horizontal",
          left: "center",
          bottom: "3%",
          textStyle: {
            color: "#C0C4CC",
            fontSize: "10",
          },
        },
        color: [
          "#1158a7",
          "#0983ff",
          "#59abf6",
          "#4682B4",
          "#abd6fc",
          "#29beb9",
          "#3bffd0",
          "#22e4ff",
        ],
        series: [
          {
            name: "PDM各厂区生产面积",
            type: "pie",
            radius: ["30%", "48%"],
            top: "-10%",
            center: "center",
            data: this.chartData,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
            label: {
              formatter: "{b}：{@2012}",
              color: "#C0C4CC",
            },
            labelLine: {
              length: 5,
            },
          },
        ],
      });
    },
    //前一月
    leftClick() {
      this.date = getNextMonth(formatTime(this.date, "yyyy-MM-dd"), -1);
      this.getData();
    },
    //后一月
    rightClick() {
      this.date = getNextMonth(formatTime(this.date, "yyyy-MM-dd"), +1);
      this.getData();
    },
  },
};
</script>

<style lang="scss" scoped>
#chart-line-item-item-box {
  // background: rgba(125, 155, 243, 0.2);
  height: 40vh;
  #right_4 {
    height: 100%;
  }
  .chart_icon_animation {
    position: absolute;
    left: 46%;
    top: 42%;
    font-size: 48px;
    color: #909399;
  }
}
</style>
